import { apiFetch } from './apiClient';

class ReportingService {
  async getOverview(organizationId) {
    return apiFetch(`/api/analytics/reporting/overview/${organizationId}`, {
      authenticated: true
    });
  }

  /**
   * Fetch analytics events for an organization within a date range (server-side query).
   */
  async getDetailedEvents(organizationId, startDate, endDate, eventType) {
    const params = new URLSearchParams({ startDate, endDate });
    if (eventType) {
      params.set('eventType', eventType);
    }
    return apiFetch(
      `/api/analytics/detailed/${organizationId}?${params.toString()}`,
      { authenticated: true }
    );
  }

  async getDashboardData(organizationId) {
    return this.getOverview(organizationId);
  }

  async getLifetimeStats(organizationId) {
    const data = await this.getOverview(organizationId);
    return { lifetimeStats: data.lifetimeStats };
  }

  async getDateRangeData(organizationId) {
    return this.getOverview(organizationId);
  }
}

const reportingService = new ReportingService();

export default reportingService;
